var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bonusBanner"},[_c('img',{attrs:{"src":_vm.img,"alt":""},on:{"click":_vm.toSign}})])
}
var staticRenderFns = []

export { render, staticRenderFns }